// File-upload constants — relocated out of CustomFileUploader.vue so the component
// carries no module-scope data tables.

export const BYTES_PER_MB = 1_048_576;

// Default client-side cap for CustomFileUploader, in MB (50 MB per AQ-W5-10). Call sites that
// need a tighter limit pass `:maxFileSizeMb` — the uploader renders that number into its own
// tip copy and rejection message, so the stated limit and the enforced limit cannot drift.
export const DEFAULT_MAX_FILE_SIZE_MB = 50;

// SasUploader's client-side size cap (MB). Single source so the SasUploader prop default, its
// call sites, and the "max N MB" helper copy can't drift (TP-6). Distinct from
// DEFAULT_MAX_FILE_SIZE_MB — SasUploader enforces a tighter limit and passes it down.
export const SAS_UPLOAD_MAX_FILE_SIZE_MB = 10;

export const EXT_TO_MIME: Record<string, string> = {
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".png": "image/png",
  ".gif": "image/gif",
  ".webp": "image/webp",
  ".bmp": "image/bmp",
  ".svg": "image/svg+xml",
  ".heic": "image/heic",
  ".heif": "image/heif",
  ".pdf": "application/pdf",
  ".csv": "text/csv",
  ".xls": "application/vnd.ms-excel",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".doc": "application/msword",
  ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".zip": "application/zip",
  ".mp4": "video/mp4",
  ".mp3": "audio/mpeg",
};

// The accept list CustomImageUpload hands to the uploader. HEIC/HEIF are on it because that is
// what an iPhone camera roll actually holds — they never reach Azure in that form, because the
// uploader re-encodes them to JPEG at pick time (see JPEG_CONVERSION_MIME_TYPES).
export const IMAGE_UPLOAD_FILE_TYPES = ".jpg,.jpeg,.png,.webp,.heic,.heif";

// Image MIME types re-encoded to JPEG before anything downstream sees them. Nothing in the stack
// reads HEIC: the Python image pipeline needs a separate decoder, an <img> pointing at a stored
// HEIC renders blank everywhere except Safari, and the vision APIs that evaluate subjective
// answers reject it outright. JPEG/PNG/WebP are deliberately absent — every consumer reads all
// three, and re-encoding a PNG to JPEG would flatten the transparency that question diagrams and
// teaching aids depend on.
export const JPEG_CONVERSION_MIME_TYPES: ReadonlyArray<string> = ["image/heic", "image/heif"];

// Quality for that re-encode: high enough that a scanned answer sheet stays legible to OMR
// template matching, without the wasted bytes of a quality-1.0 JPEG.
export const JPEG_CONVERSION_QUALITY = 0.92;

// `.jpg`/`.jpeg` and `.heic`/`.heif` are one format each as far as a user is concerned, and the
// 360px upload tip has no room to name both halves — collapsing the aliases keeps the derived
// label at "jpg/png/webp/heic" instead of "jpg/jpeg/png/webp/heic/heif".
export const FILE_TYPE_LABEL_ALIASES: Record<string, string> = { jpeg: "jpg", heif: "heic" };
